import { useGetFilesQuery, useSignedUrlMutation } from "@/services/file";
import { getContentType } from "@/utils/file-preview";
import { useEffect, useState } from "react";
import { PreviewFile } from "./file-viewer";

/**
 * Carrega os arquivos de uma entidade e resolve a URL assinada de cada um,
 * já enviando o content-type correto derivado do nome do arquivo.
 */
export const usePreviewFiles = (entityName: string, id: string) => {
  const { data } = useGetFilesQuery({ entity_name: entityName, id });
  const [signedUrl] = useSignedUrlMutation();
  const [files, setFiles] = useState<PreviewFile[]>([]);

  useEffect(() => {
    data?.data.forEach(async (file, index) => {
      const response = await signedUrl({
        id: file.id.toString(),
        ResponseContentDisposition: "inline",
        ContentType: getContentType(file.file_name),
      }).unwrap();

      setFiles((prevFiles) => {
        const updatedFiles = [...prevFiles];
        updatedFiles[index] = { name: file.file_name, url: response.url };
        return updatedFiles;
      });
    });
  }, [data]);

  /** Atualiza otimisticamente a posição com um arquivo recém-enviado (preview local). */
  const setLocalFile = (index: number, file: PreviewFile) => {
    setFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles[index] = file;
      return updatedFiles;
    });
  };

  return { files, setLocalFile };
};
